<iframe *ngIf="dataToRender" sandbox="allow-scripts" [srcdoc]="dataToRender" class="w-100 h-100 html-frame"></iframe>
